import * as THREE from "three";
import Heatpoint from '../heatpointscontrol/heatpoint';
import gsap from "gsap";

export default class LivingPlaces extends THREE.Object3D {
	constructor(pinColor, pinColorDark, camera, interactionManager, onPinClick, visitedPinColor) {
		super();

		this.setupPin(pinColor, pinColorDark, visitedPinColor, camera, interactionManager, onPinClick);
	}

	setupPin(pinColor, pinColorDark, visitedPinColor, camera, interactionManager, onPinClick) {
		this.pinModel3 = new Heatpoint(null, "model/heatpointwohn.glb");
		setTimeout(() => {
			this.pinModel3.setColor(pinColor);
		}, 1000);
		
		this.pinModel3.position.set(2.18, 0.40, -1.38);
		this.visited = false;
		interactionManager.add(this.pinModel3);

		this.pinModel3.addEventListener("click", () => this.onPinClick(pinColor, pinColorDark, visitedPinColor, camera, onPinClick));
		this.pinModel3.addEventListener('mouseover', () => this.onMouseOver(pinColorDark));
		this.pinModel3.addEventListener('mouseout', () => this.onMouseOut(pinColor, visitedPinColor));

		this.add(this.pinModel3);
		
		this.rotationAngle = 0;
		this.rotatePin();
	}

	onPinClick(pinColor, pinColorDark, visitedPinColor, camera, onPinClick) {
		onPinClick();
		gsap.to(camera.position, { x: 3.1, y: 1.2, z: -2, duration: 2.5, ease: "Power3.inOut" });
		setTimeout(() => {
			document.getElementById('modal4').classList.remove('hidden');
		}, 3000);
		this.visited = true;
		this.pinModel3.setColor(visitedPinColor);
	}

	onMouseOver(pinColorDark) {
		document.body.style.cursor = 'pointer';
		this.pinModel3.setColor(pinColorDark);
	}

	onMouseOut(pinColor, visitedPinColor) {
		document.body.style.cursor = 'default';
		this.pinModel3.setColor(this.visited ? visitedPinColor : pinColor);
	}

	rotatePin() {
		this.rotationData = { angle: 0 };
		gsap.to(this.rotationData, {
			angle: "+=" + 2 * Math.PI,
			duration: 10,
			ease: "none",
			onUpdate: () => {
				this.pinModel3.setRotationFromAxisAngle(new THREE.Vector3(0, 1, 0), this.rotationData.angle);
			},
			repeat: -1
		});
	}
}
